if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      loadDeferredImage(image) {
        if (!image?.dataset.ltpDeferredSrc) return;

        if (image.dataset.ltpDeferredSrcset) image.srcset = image.dataset.ltpDeferredSrcset;
        image.src = image.dataset.ltpDeferredSrc;
        delete image.dataset.ltpDeferredSrcset;
        delete image.dataset.ltpDeferredSrc;
      }

      observeDeferredImages(container, activeImage) {
        const deferredImages = Array.from(this.querySelectorAll('img[data-ltp-modal-image][data-ltp-deferred-src]'));
        if (!deferredImages.length) return;

        if (!('IntersectionObserver' in window)) {
          deferredImages.forEach((image) => this.loadDeferredImage(image));
          return;
        }

        this.deferredImageObserver?.disconnect();
        this.deferredImageObserver = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (!entry.isIntersecting) return;
              this.loadDeferredImage(entry.target);
              this.deferredImageObserver.unobserve(entry.target);
            });
          },
          { root: container, rootMargin: '100% 0px' }
        );

        deferredImages.forEach((image) => {
          if (image !== activeImage) this.deferredImageObserver.observe(image);
        });
      }

      showActiveMedia() {
        this.querySelectorAll(
          `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`
        ).forEach((element) => {
          element.classList.remove('active');
        });
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        const activeImage = activeMedia.matches('img[data-ltp-modal-image]')
          ? activeMedia
          : activeMedia.querySelector('img[data-ltp-modal-image]');
        this.loadDeferredImage(activeImage);
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;
        this.observeDeferredImages(container, activeImage);

        if (
          activeMedia.nodeName == 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        )
          activeMedia.loadContent();
      }
    }
  );
}
